import './PrivacyPolicy.css';
import Navbar from '../Navbar/Navbar'; 
import '../../assets/css/style.css';
import Footer from '../Footer/Footer';

const PrivacyPolicy = () => {
    
    return (
      <>
		 <div className="main-wrapper">
		 <header class="header">
                <Navbar />
            </header>
		
			{/* <!-- Breadcrumb --> */}
<div class="breadcrumb-bar">
	<div class="container-fluid">
	  <div class="row align-items-center">
		<div class="col-md-12 col-12">
		  <nav aria-label="breadcrumb" class="page-breadcrumb">
			<ol class="breadcrumb">
			  <li class="breadcrumb-item"><a href="index.html">Home</a></li>
			  <li class="breadcrumb-item active" aria-current="page">Privacy-policy</li>
			</ol>
		  </nav>
		  <h2 class="breadcrumb-title">Privacy-Policy</h2>
		</div>
	  </div>
	</div>
  </div>
  {/* <!-- /Breadcrumb --> */}
		
		<div className="content">
			<div className="container">
				<div className="row">
					<div className="col-12">
						 <div className="terms-content">
							<div className="terms-text">
								 <p>Effective Date: [10-01-2027]</p>
								<p>At Hitkari Hospital, we are committed to ensuring the confidentiality and protection of your personal information. This Privacy Policy governs the collection, use, disclosure, and protection of your personal data when you access or use our services, website, or any associated features. By using our services, you explicitly consent to the practices described herein.</p>
							   </div>
							   <div className="terms-text">
									<h3>1. Information We Collect</h3>
									 <p>In accordance with applicable data protection laws, Hitkari Hospital collects personal information, including but not limited to your name, contact details, medical history, and any other information voluntarily provided through appointment forms, contact forms, and interactions with our services. Additionally, we collect non-personally identifiable information through cookies, IP addresses, and web analytics tools, for the purpose of improving our services and user experience.</p>
								</div>
							<div className="terms-text">
								  <h3>2. Purpose and Use of Collected Information</h3>
								   <p>The information we collect will be used solely for the purposes outlined in this policy and as necessary for the lawful performance of our healthcare services. Specifically, we use your personal information to:</p>
									<ul>
										<li>Provide and manage healthcare services tailored to your specific needs.</li>
										<li>Process and confirm appointments, medical billing, and insurance information.</li>
										 <li>Respond to inquiries, provide relevant healthcare information, and personalize your experience.</li>
									   <li>Keep you informed of updates, newsletters, promotions, and medical services that may be of interest. We will not use your data for purposes beyond those stated without obtaining your explicit consent.</li>
									  </ul>
							  </div>
							<div className="terms-text">
								<h3>3. Data Security and Protection</h3>
								 <p>We take the privacy and security of your personal data seriously. In compliance with applicable privacy laws, we implement strict security measures, including SSL encryption, firewalls, and access control protocols to prevent unauthorized access, disclosure, alteration, or destruction of your personal information. Despite our rigorous efforts, no method of transmission over the Internet or electronic storage can be guaranteed 100% secure. Therefore, while we strive to protect your information, we cannot guarantee its absolute security.</p>
							 </div>
							<div className="terms-text">
							  <h3>4. Third-Party Disclosure</h3>
							   <p>We do not sell, rent, or trade your personal information. However, we may share your personal data with trusted third-party vendors and service providers, solely for the purposes of:</p>
								<ul>
									 <li>Providing healthcare services.</li>
									 <li>Processing payments and managing insurance claims.</li>
									  <li>Facilitating communications related to appointments or medical follow-up. All third-party service providers are contractually obligated to comply with confidentiality and data protection obligations in accordance with applicable data protection laws, and their use of your data will be restricted to the services they provide to Hitkari Hospital.</li>
								 </ul>
							</div>
							 <div className="terms-text">
								<h3>5. Cookies and Tracking Technologies</h3>
								<p>To improve user experience and tailor content, we may use cookies or similar tracking technologies. These technologies help us monitor user activity on the website, analyze trends, and enhance the functionality of our website. By using our website, you consent to the use of these tracking technologies as described. You may disable cookies through your browser settings, but this may limit the functionality of certain features on our website.</p>
							</div>
							  <div className="terms-text">
							   <h3>6. Your Rights</h3> <br />
								<p>Under applicable data protection laws, you have the right to:</p>
								<ul>
									  <li>Access the personal data we hold about you.</li>
									   <li>Correct or update any inaccuracies in your personal information.</li>
										<li>Request the deletion of your personal information, subject to legal retention obligations.</li>
									  <li>Withdraw consent for processing your personal data, where consent is the basis for processing.</li>
										 <li>Object to processing of your personal data for direct marketing or profiling purposes. To exercise these rights or for any inquiries regarding your personal information, please contact us using the contact details below.</li>
								 </ul>
							  </div>
							   <div className="terms-text">
								  <h3>7. Updates to Privacy Policy</h3>
									<p>We reserve the right to update or amend this Privacy Policy at our discretion and in accordance with changes in applicable data protection laws. Any amendments will be posted on this page, and we will revise the "Effective Date" accordingly. We recommend reviewing this Privacy Policy periodically to stay informed about how we are protecting your privacy.</p>
							   </div>
							   <div className="terms-text">
								<h3>8. Contact Information</h3>
								 <p>For any questions, concerns, or requests regarding this Privacy Policy or the management of your personal information, please contact us at:</p>
								   <p>Hitkari Hospital</p>
								   <p>Near MTM School, Balotra, Distt. Barmer, Rajasthan, PIN 344022</p>
								 <p>Email: <a href="mailto:hitkarihospitalblt2015@gmail.com">hitkarihospitalblt2015@gmail.com.</a></p>
								<br /><p> Phone: +91 9462621101</p>

							  </div>
						</div>
					</div>
				</div>
			</div>

		</div>
    </div>
    <Footer/>
    </>
    );
};

export default PrivacyPolicy;